import * as React from 'react';
import { ChakraProvider, CSSReset } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import { theme } from './theme';

// locales
import './constants/locales/i18n';
import AppRouter from './routes';
import { AuthProvider } from './providers/auth';
import { AnchoredToastProvider, ToastProvider } from './components/ui/toast';

export function App() {
  return (
    <ChakraProvider theme={theme}>
      <CSSReset />
      <ToastProvider position="top-right">
        <AnchoredToastProvider>
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <AuthProvider>
              <AppRouter />
            </AuthProvider>
          </BrowserRouter>
        </AnchoredToastProvider>
      </ToastProvider>
    </ChakraProvider>
  );
}
